import type { MouseEvent } from 'react'
import { Box } from '@mui/material'
import Check from '@mui/icons-material/Check'

const CheckBox = (props: {
  value?: boolean
  onChecked: (value: boolean, event?: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
}) => {
  // Users of CheckBox must provide:
  // 1) value - true/false that sets state of then checkbox
  // 2) onChecked - a callback function that runs every time a user clicks on the checkbox

  const { value, onChecked, disabled } = props

  return (
    <Box
      component="button"
      sx={{
        background: 'inherit',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        '&:focus': { outline: '0' },
      }}
      onClick={event => onChecked(!value, event)}
      disabled={disabled}
    >
      <Check
        sx={[
          {
            borderRadius: '0.5rem',
            mr: 1,
            fontSize: '2.5rem',
            padding: '.1rem',
            width: '.8em',
            height: '.8em',
          },
          value
            ? { bgcolor: 'primary.main', color: 'common.white' }
            : {
                border: '0.2rem solid',
                borderColor: 'primary.main',
                color: 'background.default',
                bgcolor: 'background.default',
                '&:hover': { bgcolor: 'primary.light', color: 'primary.light' },
              },
          !!disabled &&
            (value
              ? { bgcolor: 'secondary.light', color: 'common.white' }
              : { borderColor: 'secondary.light', bgcolor: 'common.white', color: 'common.white' }),
        ]}
      />
    </Box>
  )
}

export default CheckBox
